define(['constants', 'dataServices', 'payService', 'chartPayService', 'appInit', 'baseApi', 'collectApi', 'userApi', 'observer', 'loginBox'],
    function (constants, dataServices, payService, chartPayService, appInit, baseApi, collectApi, userApi, observer, loginBox) {
  const PayWay = { ALIPAY: 0, WECHAT: 1, RICE: 2 };
  const payWays = [
    'zfb_qrcode', // 支付宝二维码
    'wx_qrcode', // 微信二维码
    'daomi' // 稻米支付
  ];

  const chargePrices = [ 30, 50 ];

  var PAY_CHANNEL = '';
  var PAY_SUB_CHANNEL = '';
  var PAY_ORIGIN = '';

  const IC_PAYWAY_INDEX = PayWay;

  const IC_TARGET_INDEX = {
    TEMPLATE: 1,
    RICE: 2,
  };

  const IC_TEMPLATE_BTN_INDEX = {
    CLOSE: 1,
    TAB_ALIPAY: 2,
    LINK_ALIPAY: 3,
    TAB_WECHAT: 4,
    TAB_RICE: 5,
    LINK_RICE_PAY: 6,
    LINK_RICE_CHARGE: 7,
  };

  const IC_RICE_BTN_INDEX = {
    CLOSE: 1,
    TAB_ALIPAY: 2,
    LINK_ALIPAY: 3,
    TAB_WECHAT: 4,
    TAB_RICE: 5,
    LINK_RICE: 6,
    PRICE_30: 7,
    PRICE_50: 8,
    PRICE_OTHER: 9,
  };

  const IC_RESULT_INDEX = {
    PAYING: 1,
    FAILED: 2,
  };

  const IC_BRANCH_BTN_INDEX = {
    PAYING_FINISH: 1,
    PAYING_REPAY: 2,
    PAY_FAIL_REPAY: 3,
  };

  const pollingCheckOrder = function (isOrderPaidFunc, wpsSid, requestCheckOrderIdFunc, paidCallback, timeoutCallback) {
    const CHECK_INTERVAL = 3000; // 轮询间隔
    const MAX_CHECK_MINUTES = 3; // 支付超时限制 (NOTE: 暂时设置1分钟过期, 正式版需要改回)
    const MAX_CHECK_LIMIT = MAX_CHECK_MINUTES * 60 * 1000 / CHECK_INTERVAL;

    let checkOrderId = requestCheckOrderIdFunc();
    let checkedCount = 0;

    let _check = function () {
      if (checkOrderId !== requestCheckOrderIdFunc()) {
        return;
      }
      checkedCount++;
      isOrderPaidFunc(wpsSid, checkOrderId).done((isPaid) => {
        if (isPaid) {
          paidCallback && paidCallback();
        } else {
          _checkAgain();
        }
      }).fail(_checkAgain); // 检查失败也继续检查
    };

    let _checkAgain = function () {
      if (checkedCount < MAX_CHECK_LIMIT) {
        setTimeout(_check, CHECK_INTERVAL);
      } else {
        timeoutCallback && timeoutCallback();
      }
    };

    _check();
  };

  var model = avalon.define('PaymentCtrl', function(vm) {
    vm.$skipArray = [];

    vm.screenType = null;

    var statuses = {
      isNetworkError: { icon: 'network-error-96', retry: true,  msg: '断网了！无法加载页面，请检查您的网络' },
      isServerError:  { icon: 'server-error-96',  retry: true,  msg: '服务器维护中，请稍后再试' },
      isUnknownError: { icon: 'unknown-error-96', retry: true,  msg: '页面加载失败，请重新尝试' },
    };

    vm.view = {
      isLoading: false,
      isNetworkError: false,
      isServerError: false,
      isUnknownError: false,
      isLoaded: false,
      icon: '',
      message: '',
      retryVisible: false,

      switchToStatus: function (name) {
        var self = model.view;
        self.isLoading = false;
        self.isNetworkError = false;
        self.isServerError = false;
        self.isUnknownError = false;
        self.isLoaded = false;

        self[name] = true;
        var status = statuses[name];
        if (status) {
          self.icon = status.icon;
          self.message = status.msg;
          self.retryVisible = status.retry;
        }
      },

      loading: function () {
        model.view.switchToStatus('isLoading');
      },

      networkError: function () {
        model.view.switchToStatus('isNetworkError');
      },

      serverError: function () {
        model.view.switchToStatus('isServerError');
      },

      unknownError: function () {
        model.view.switchToStatus('isUnknownError');
      },

      loaded: function () {
        model.view.switchToStatus('isLoaded');
      }
    };

    vm.unknownError = false;

    vm.isPayForTemplate = false;
    vm.isPayForRice = false;

    vm.displayInfo = null;
    vm.infoCollectOptions = null;
    vm.payChannelInfo = null;
    vm.callbacks = null;
    vm.transferData = null;

    vm.templateId = null;

    vm.isLogined = false;
    vm.wpsSid = '';
    vm.user = { loaded: false, nickname: '', wealth: 0 };

    // 登录提示框
    vm.loginBoxModel = null;

    vm.loginBoxOption = {
      visible: false,

      onInit(el, widgetModel) {
        model.loginBoxModel = widgetModel;
      },
      onClose() {
        model.closeWindow();
      },
      onLogin() {
        userApi.login();
      }
    };

    vm.template = {
      payWayIndex: 0,
      alipayQRCode: {
        url: '',
        isLoaded: false,
        isError: false,
        isTimeout: false
      },
      wechatQRCode: {
        url: '',
        isLoaded: false,
        isError: false,
        isTimeout: false
      },
      orderId: null,

      checkingOrderId: null,

      view: {
        isSelecting: true,
        isPaying: false,
        isBrowserPaying: false,
        isSucceed: false,
        isFailed: false,

        succeedText: '',
        failedText: '',

        switchToStatus: function (state) {
          var self = model.template.view;
          self.isSelecting = false;
          self.isPaying = false;
          self.isBrowserPaying = false;
          self.isSucceed = false;
          self.isFailed = false;
          self[state] = true;
        },

        selecting: function () {
          model.template.view.switchToStatus('isSelecting');
        },

        paying: function () {
          model.template.view.switchToStatus('isPaying');
        },

        browserPaying: function () {
          model.template.view.switchToStatus('isBrowserPaying');
        },

        succeed: function () {
          model.template.view.switchToStatus('isSucceed');
        },

        failed: function () {
          model.template.view.switchToStatus('isFailed');
        }
      },

      selectPayWay: function (index) {
        var self = model.template;
        self.payWayIndex = index;
        self.view.selecting();
        self.view.succeedText = '支付成功';
        self.view.failedText = '支付失败';
        self.stopCheckQRCodePayStatus();
        if (index == PayWay.ALIPAY || index == PayWay.WECHAT) {
          self.getQRCode();
        } else {
          //model.getUserRiceInfo();
          // TODO: updateRiceInfo
        }
        collectApi.sendPaymentClickBtn(IC_TARGET_INDEX.TEMPLATE,
          [IC_TEMPLATE_BTN_INDEX.TAB_ALIPAY, IC_TEMPLATE_BTN_INDEX.TAB_WECHAT, IC_TEMPLATE_BTN_INDEX.TAB_RICE][index]
        );
      },

      getQRCode: function () {
        var self = model.template;
        var payWayIndex = self.payWayIndex;
        let qrCode = payWayIndex === PayWay.ALIPAY ? self.alipayQRCode : self.wechatQRCode;
        qrCode.isLoaded = false;
        qrCode.isError = false;
        qrCode.isTimeout = false;

        payService.getPayQrCode(model.wpsSid, model.templateId, payWays[self.payWayIndex], PAY_CHANNEL, PAY_SUB_CHANNEL, PAY_ORIGIN).done(function (data) {
          let qrCode = payWayIndex === PayWay.ALIPAY ? self.alipayQRCode : self.wechatQRCode;
          qrCode.url = data.qrcode_url || data.url;
          model.loadImg(qrCode);
          self.orderId = data.order_num;
          self.checkQRCodePayStatus(self.orderId);
        }).fail(function (msg) {
          if (msg === 'is_buy') { // 重复购买
            self.view.succeedText = '您已购买';
            self.onPaymentSuccess();
          } else {
            if (payWayIndex === PayWay.ALIPAY) {
              self.alipayQRCode.isError = true;
            } else {
              self.wechatQRCode.isError = true;
            }
            collectApi.sendPaymentLoadFail(collectApi.IC_FAIL_TARGET.QRCODE);
          }
        });
      },

      payWithRice: function () {
        var self = model.template;
        self.view.paying();
        payService.payByRice(model.wpsSid, model.templateId, PAY_CHANNEL, PAY_SUB_CHANNEL, PAY_ORIGIN).done(function (data) {
          self.onPaymentSuccess();
          self.collectPaymentInfo();
        }).fail(function (msg) {
          if (msg === 'is_buy') { // 重复购买
            self.view.succeedText = '您已购买';
            self.onPaymentSuccess();
          } else {
            self.onPaymentFailed();
          }
        });
        collectApi.sendPaymentClickBtn(IC_TARGET_INDEX.TEMPLATE, IC_TEMPLATE_BTN_INDEX.LINK_RICE_PAY);
      },

      collectPaymentInfo: function () {
        payService.recordPayment(model.wpsSid, model.templateId);
      },

      checkQRCodePayStatus: function (checkingOrderId) {
        let self = model.template;
        self.checkingOrderId = checkingOrderId;
        pollingCheckOrder(payService.isOrderPaid, model.wpsSid, () => self.checkingOrderId, () => {
          self.onPaymentSuccess();
          self.collectPaymentInfo();
        }, () => {
          self.onPaymentTimeout();
        });
      },

      stopCheckQRCodePayStatus: function () {
        var self = model.template;
        self.checkingOrderId = null;
      },

      onPaymentSuccess: function () {
        var self = model.template;
        self.view.succeed();
        model.emitPaySuccess();
        setTimeout(function () {
          model.closeWindow();
        }, 3000); // 三秒后自动关闭
      },

      onPaymentFailed: function () {
        var self = model.template;
        self.view.failed();
        collectApi.sendPaymentBranchDisplay(IC_TARGET_INDEX.TEMPLATE, IC_RESULT_INDEX.FAILED);
      },

      onPaymentTimeout: function () {
        let self = model.template;
        let payWayIndex = self.payWayIndex;
        let qrCode = payWayIndex === PayWay.ALIPAY ? self.alipayQRCode : self.wechatQRCode;
        qrCode.isTimeout = true;
        qrCode.isError = false;
        qrCode.isLoaded = false;
      },

      retryPay: function () {
        model.testNetwork();
        var self = model.template;
        self.selectPayWay(self.payWayIndex);
        collectApi.sendPaymentBranchClickBtn(IC_TARGET_INDEX.TEMPLATE, self.payWayIndex + 1, IC_BRANCH_BTN_INDEX.PAY_FAIL_REPAY);
      },

      payViaAlipayAccount: function () {
        var self = model.template;
        payService.fetchAlipayUrl(model.wpsSid, self.orderId, PAY_ORIGIN).done((url) => {
          self.view.browserPaying();
          self.view.succeedText = '您已支付成功';
          self.view.failedText = '您还没有完成付款';
          baseApi.openUrl(url);
          self.stopCheckQRCodePayStatus();
          collectApi.sendPaymentBranchDisplay(IC_TARGET_INDEX.TEMPLATE, IC_RESULT_INDEX.PAYING);
        }).fail(function () {
          self.view.failed();
          collectApi.sendPaymentBranchDisplay(IC_TARGET_INDEX.TEMPLATE, IC_RESULT_INDEX.FAILED);
        });
        collectApi.sendPaymentClickBtn(IC_TARGET_INDEX.TEMPLATE, IC_TEMPLATE_BTN_INDEX.LINK_ALIPAY);
      },

      finishPay: function () {
        var self = model.template;
        payService.isOrderPaid(model.wpsSid, self.orderId).done((isPaid) => {
          if (isPaid) {
            // self.onPaymentSuccess();
            // 直接进入支付后的流程
            self.collectPaymentInfo();
            model.emitPaySuccess();
            model.closeWindow();
          } else {
            self.onPaymentFailed();
          }
        }).fail(function () {
          self.onPaymentFailed();
        });
        collectApi.sendPaymentBranchClickBtn(IC_TARGET_INDEX.TEMPLATE, self.payWayIndex + 1, IC_BRANCH_BTN_INDEX.PAYING_FINISH);
      },

      repay: function () {
        var self = model.template;
        payService.isOrderPaid(model.wpsSid, self.orderId).done((isPaid) => {
          if (isPaid) {
            self.onPaymentSuccess();
            self.collectPaymentInfo();
          } else {
            self.retryPay();
          }
        }).fail(function () {
          self.retryPay();
        });
        collectApi.sendPaymentBranchClickBtn(IC_TARGET_INDEX.TEMPLATE, self.payWayIndex + 1, IC_BRANCH_BTN_INDEX.PAYING_REPAY);
      }
    };

    vm.rice = {
      payWayIndex: 0,
      alipayQRCode: {
        url: '',
        isLoaded: false,
        isError: false
      },
      wechatQRCode: {
        url: '',
        isLoaded: false,
        isError: false
      },
      orderId: null,

      checkingOrderId: null,
      checkPayStatusCount: 0,

      view: {
        isSelecting: true,
        isPaying: false,
        isBrowserPaying: false,
        isSucceed: false,
        isFailed: false,

        succeedText: '',
        failedText: '',

        switchToStatus: function (state) {
          var self = model.rice.view;
          self.isSelecting = false;
          self.isPaying = false;
          self.isBrowserPaying = false;
          self.isSucceed = false;
          self.isFailed = false;
          self[state] = true;
        },

        selecting: function () {
          model.rice.view.switchToStatus('isSelecting');
        },

        paying: function () {
          model.rice.view.switchToStatus('isPaying');
        },

        browserPaying: function () {
          model.rice.view.switchToStatus('isBrowserPaying');
        },

        succeed: function () {
          model.rice.view.switchToStatus('isSucceed');
        },

        failed: function () {
          model.rice.view.switchToStatus('isFailed');
        }
      },

      selectPayWay: function (index) {
        var self = model.rice;
        self.payWayIndex = index;
        self.view.selecting();
        self.view.succeedText = '充值成功';
        self.view.failedText = '充值失败';
        self.stopCheckQRCodePayStatus();
        self.selectChargePrice(self.chargePriceIndex);
        if (index == PayWay.ALIPAY || index == PayWay.WECHAT) {
          self.getQRCode();
        }
        collectApi.sendPaymentClickBtn(IC_TARGET_INDEX.RICE,
          [IC_RICE_BTN_INDEX.TAB_ALIPAY, IC_RICE_BTN_INDEX.TAB_WECHAT, IC_RICE_BTN_INDEX.TAB_RICE][index]
        );
      },

      refreshQrCode: function () {
        var self = model.rice;
        self.stopCheckQRCodePayStatus();
        self.getQRCode();
      },

      customChargePrice: null,

      chargePriceIndex: 0,

      chargePrice: 0,

      displayChargePrice: 0,

      lastTimeoutId: null,
      selectChargePrice: function (index) {
        var self = model.rice;
        self.chargePriceIndex = index;

        if (index == -1) {
          var price = parseInt(self.customChargePrice);
          if (!price)
            return;
          self.chargePrice = price;
          self.alipayQRCode.isLoaded = false;
          self.wechatQRCode.isLoaded = false;
          self.alipayQRCode.isError = false;
          self.wechatQRCode.isError = false;
          if (self.lastTimeoutId !== null)
            clearTimeout(self.lastTimeoutId);
          self.lastTimeoutId = setTimeout(function(){
            self.displayChargePrice = self.chargePrice;
            self.refreshQrCode();
            collectApi.sendPaymentClickBtn(IC_TARGET_INDEX.RICE, IC_RICE_BTN_INDEX.PRICE_OTHER);
          }, 500);
          return;
        }

        self.customChargePrice = null;
        self.chargePrice = chargePrices[self.chargePriceIndex];
        self.displayChargePrice = self.chargePrice;
        self.refreshQrCode();
        collectApi.sendPaymentClickBtn(IC_TARGET_INDEX.RICE,
          [IC_RICE_BTN_INDEX.PRICE_OTHER/* index == -1 */, IC_RICE_BTN_INDEX.PRICE_30, IC_RICE_BTN_INDEX.PRICE_50][index + 1]
        );
      },

      getQRCode: function () {
        var self = model.rice;
        var payWayIndex = self.payWayIndex;
        if (payWayIndex === PayWay.ALIPAY) {
          self.alipayQRCode.isLoaded = false;
          self.alipayQRCode.isError = false;
        } else {
          self.wechatQRCode.isLoaded = false;
          self.wechatQRCode.isError = false;
        }
        self.doPay().done(function (data) {
          if (payWayIndex == PayWay.ALIPAY) {
            self.alipayQRCode.url = data.url;
            model.loadImg(self.alipayQRCode);
          } else /* PayWay.WECHAT */ {
            self.wechatQRCode.url = data.url;
            model.loadImg(self.wechatQRCode);
          }

          self.orderId = data.order_num;

          self.checkQRCodePayStatus(self.orderId);
        }).fail(function (msg) {
          if (msg == "is_buy") { // 重复购买
            self.onPaymentSuccess();
          } else {
            if (payWayIndex === PayWay.ALIPAY) {
              self.alipayQRCode.isError = true;
            } else {
              self.wechatQRCode.isError = true;
            }
            collectApi.sendPaymentLoadFail(collectApi.IC_FAIL_TARGET.QRCODE);
          }
        });
      },

      doPay: function () {
        var self = model.rice;
        var dfd = $.Deferred();
        console.log(model.wpsSid);
        dataServices.get('vip').payForRice({
          cookie: {
            wps_sid: model.wpsSid
          }, data: {
            memtype: 1000,
            csource: PAY_ORIGIN,
            count: self.chargePrice * 100, // 充值稻米数
            payway: payWays[self.payWayIndex],
            prepay: 0
          }
        }).done(function (result) {
          if (result.result == 'ok') {
            dfd.resolve(result.data);
          } else {
            dfd.reject(result.msg);
          }
        }).fail(function () {
          dfd.reject();
        });
        return dfd;
      },

      checkQRCodePayStatus: function (checkingOrderId) {
        var self = model.rice;

        const CHECK_INTERVAL = 3000; // 轮询间隔
        const MAX_CHECK_MINUTES = 20; // 支付超时限制
        const MAX_CHECK_LIMIT = MAX_CHECK_MINUTES * 60 * 1000 / CHECK_INTERVAL;

        self.checkingOrderId = checkingOrderId;
        self.checkPayStatusCount = 0;

        (function check(orderId) {
          if (orderId != self.checkingOrderId) {
            return; // 如已产生新订单号, 则停止本次检查
          }

          self.checkPayStatusCount++;
          dataServices.get('vip').checkPayStatus({
            cookie: {
              wps_sid: model.wpsSid
            }, data: {
              order_id: orderId
            }
          }).done(function (result) {
            if (result.result == 'ok') {
              var payStatus = result.data.status;
              if (payStatus == 'finish') {
                self.onPaymentSuccess();
              } else {
                if (self.checkPayStatusCount < MAX_CHECK_LIMIT) {
                  setTimeout(function () {
                    check(orderId);
                  }, CHECK_INTERVAL); // 等待一段时间后再次检查支付状态
                }
              }
            } else {
              // TODO
            }
          }).fail(function () {
            // TODO
          });
        })(self.checkingOrderId);
      },

      stopCheckQRCodePayStatus: function () {
        var self = model.rice;
        self.checkingOrderId = null;
      },

      onPaymentSuccess: function () {
        var self = model.rice;
        self.view.succeed();
        setTimeout(function () {
          self.finishCharge();
        }, 3000); // 三秒后自动跳转
      },

      onPaymentFailed: function () {
        var self = model.rice;
        self.view.failed();
        collectApi.sendPaymentBranchDisplay(IC_TARGET_INDEX.RICE, IC_RESULT_INDEX.FAILED);
      },

      finishCharge: function () {
        model.queryUserInfoAndSelectPayWay();
      },

      retryPay: function () {
        model.testNetwork();
        var self = model.rice;
        self.selectPayWay(self.payWayIndex);
        collectApi.sendPaymentBranchClickBtn(IC_TARGET_INDEX.RICE, self.payWayIndex + 1, IC_BRANCH_BTN_INDEX.PAY_FAIL_REPAY);
      },

      payViaAlipayAccount: function () {
        var self = model.rice;
        self._fetchAlipayUrl().done(function (result) {
          var url = result.url;
          self.view.browserPaying();
          self.succeedText = '您已支付成功';
          self.failedText = '您还没有完成付款';
          baseApi.openUrl(url);
          self.stopCheckQRCodePayStatus();
          collectApi.sendPaymentBranchDisplay(IC_TARGET_INDEX.RICE, IC_RESULT_INDEX.PAYING);
        }).fail(function () {
          self.view.failed();
          collectApi.sendPaymentBranchDisplay(IC_TARGET_INDEX.RICE, IC_RESULT_INDEX.FAILED);
        });
        collectApi.sendPaymentClickBtn(IC_TARGET_INDEX.RICE, IC_RICE_BTN_INDEX.LINK_ALIPAY);
      },

      _fetchAlipayUrl: function () {
        var self = model.rice;
        var dfd = $.Deferred();
        dataServices.get('vip').payForRice({
          cookie: {
            wps_sid: model.wpsSid
          }, data: {
            memtype: 1000,
            csource: PAY_ORIGIN,
            count: self.chargePrice * 100, // 充值稻米数
            payway: 'alipay', // 返回支付宝网页支付地址
            prepay: 0
          }
        }).done(function (result) {
          if (result.result == 'ok') {
            dfd.resolve(result.data);
          } else {
            dfd.reject(result.msg);
          }
        }).fail(function () {
          dfd.reject();
        });
        return dfd;
      },

      finishPay: function () {
        var self = model.rice;
        self.finishCharge();
        collectApi.sendPaymentBranchClickBtn(IC_TARGET_INDEX.RICE, self.payWayIndex + 1, IC_BRANCH_BTN_INDEX.PAYING_FINISH);
      },

      repay: function () {
        var self = model.rice;
        self.retryPay();
        collectApi.sendPaymentBranchClickBtn(IC_TARGET_INDEX.RICE, self.payWayIndex + 1, IC_BRANCH_BTN_INDEX.PAYING_REPAY);
      },

      payViaVipSite: function () {
        var self = model.rice;
        self.view.browserPaying();
        self.view.succeedText = '您已支付成功';
        self.view.failedText = '您还没有完成付款';
        baseApi.openUrl('http://vip.wps.cn/pay/daomi/', true/*自动登录*/);
        self.stopCheckQRCodePayStatus();
        collectApi.sendPaymentClickBtn(IC_TARGET_INDEX.RICE, IC_RICE_BTN_INDEX.LINK_RICE);
        collectApi.sendPaymentBranchDisplay(IC_TARGET_INDEX.RICE, IC_RESULT_INDEX.PAYING);
      }
    };

    var failFunc = function (errorCode) {
      if (errorCode == 'NETWORK_ERROR') {
        model.view.networkError();
      } else if (errorCode == 'NETWORK_TIMEOUT') {
        model.view.serverError();
      } else {
        model.view.unknownError();
      };
    };

    vm.loadImg = function (item, url, callback) {
      url = url || item.url;
      item.isLoaded = false;
      item.isError = false;
      $('<img/>').load(function () {
        item.isLoaded = true;
        callback && callback();
        $(this).unbind();
      }).error(function () {
        item.isError = true;
        $(this).unbind();
      }).attr('src', url);
    };

    vm.init = function () {
      appInit();

      $('.numbers-only').bind('input', function () {
          if (this.value != this.value.replace(/[^0-9]/g, '')) {
             this.value = this.value.replace(/[^0-9]/g, '');
          }
          model.rice.customChargePrice = this.value;
          model.rice.selectChargePrice(-1);
      });


      observer(userApi.CHANNEL_USER_STATE_CHANGED).subscribe(function (isLogined, wpsSid) {
        model.isLogined = isLogined;
        model.wpsSid = wpsSid;

        var loginBoxModel = model.loginBoxModel;
        if (!loginBoxModel) {
          return;
        }

        if (!isLogined) {
          loginBoxModel.show();
        } else {
          if (loginBoxModel.visible) {
            loginBoxModel.hide();
            var view = model.view;
            view.loading();
            payService.isBought(wpsSid, model.templateId).done((paid) => {
              if (paid) {
                // 已购买，返回
                model.emitPaySuccess();
                model.closeWindow();
              } else {
                // 未购买，刷新界面
                var isPayForRice = model.isPayForRice;
                view.loaded();
                model.refresh();
                if (isPayForRice) {
                  model.rechargeRice();
                }
              }
            }).fail(failFunc);
          }
        }
      });

      model.loadTransferData().done(function () {
        avalon.scan();
        model.queryUserInfoAndSelectPayWay();
        userApi.checkUserLogin();
      });

      baseApi.executeInTestEnv(function () {
        window.model = model; // 测试环境下公开model, 方便调试
      });
    };

    vm.loadTransferData = function () {
      let dfd = $.Deferred();
      baseApi.getWebViewProperty("paymentInfo").done((data) => {
        //alert(JSON.stringify(data));
        baseApi.executeInTestEnv(function () {
          // 测试数据
          data = data || {
            displayInfo: {
              "customFields":[
                { key: '设计师', value: 'Athena' },
                { key: '页数', value: '共87页' }
              ],
              "previewImgUrl":"http://img1.file.cache.docer.com/storage/preview/3/8/1/4/a/b9e36a09353e7e36cdabb0872df52b04.png/116x65.png",
              "price":20,
              "title":"设计方案"
            },
            infoCollectOptions: {
              "moduleName":"newFile"
            },
            payChannelInfo: {"channel":"meihua","origin":"wpp_meihua_new_file","sub_channel":"new_file"},
            screenType: {"displayText":"宽屏16:9","text":"16:9","value":2}, // TODO
            serviceName: "beautifydocument", // TODO
            templateId: 817834,
            wpsSid: "825a7871da9c9b6f36fce9983ebf4c20915ae24d00034777d8",
            callbacks: {
              onPaySuccess: 'onPaySuccess'
            }
          };
        });

        model.displayInfo = data.displayInfo;
        delete data.displayInfo;

        let payChannelInfo = data.payChannelInfo;
        delete data.payChannelInfo;
        PAY_CHANNEL = payChannelInfo.channel;
        PAY_SUB_CHANNEL = payChannelInfo.sub_channel;
        PAY_ORIGIN = payChannelInfo.origin;

        let infoCollectOptions = data.infoCollectOptions;
        delete data.infoCollectOptions;
        collectApi.setModuleName(infoCollectOptions.moduleName);

        if (data.serviceName === 'onlinechart') {
          payService = chartPayService; // TODO
        }

        model.screenType = data.screenType || { "text": "16:9", "value": 2 };
        model.wpsSid = data.wpsSid;
        model.templateId = data.templateId;

        model.callbacks = data.callbacks;
        delete data.callbacks;

        model.transferData = data;

        dfd.resolve();
      });
      return dfd.promise();
    };

    vm.updateDragArea = function () {
      var widthBtnGroup1 = 150;
      var widthBtnGroup2 = 32;
      /*
      if (model.isPayForRice) {
        baseApi.setDragArea(widthBtnGroup1, 0, 950 - widthBtnGroup1 - widthBtnGroup2, 30);
      } else {
        baseApi.setDragArea(0, 0, 950 - widthBtnGroup2, 30);
      }*/
      // setDragArea方法不支持清除上次设置的拖动区域，即基于上次设置区域再次设置，非完全重新设置拖动区域
      baseApi.setDragArea(widthBtnGroup1, 0, 950 - widthBtnGroup1 - widthBtnGroup2, 30);
    };

    vm.emitPaySuccess = function () {
      if (model.callbacks && model.callbacks.onPaySuccess) {
        baseApi.returnPaymentResult(model.callbacks.onPaySuccess);
      }
    };

    vm.closeWindow = function () {
      if (model.template.view.isPaying) {
        return;
      }

      if (model.isPayForTemplate) {
        if (model.template.view.isSelecting) {
          collectApi.sendPaymentClickBtn(IC_TARGET_INDEX.TEMPLATE, IC_TEMPLATE_BTN_INDEX.CLOSE);
        }
      } else {
        if (model.rice.view.isSelecting) {
          collectApi.sendPaymentClickBtn(IC_TARGET_INDEX.RICE, IC_RICE_BTN_INDEX.CLOSE);
        }
      }

      // 停止扫码结果轮询
      model.template.stopCheckQRCodePayStatus();
      model.rice.stopCheckQRCodePayStatus();
      baseApi.closeWindow();
    };

    vm.testNetwork = function() {
      dataServices.get('docer').user({ cookie: {
        wps_sid: model.wpsSid
      }}).fail(failFunc);
    }

    var uiInited = false;
    vm.queryUserInfoAndSelectPayWay = function () {
      model.isPayForTemplate = true;
      model.isPayForRice = false;
      model.updateDragArea();

      // 测试使用
      if (!baseApi.isWpsEnv()) {
        model.template.selectPayWay(PayWay.ALIPAY);

        model.user.nickname = 'test';
        model.user.wealth = 0;
        model.user.loaded = true;

        model.view.loaded();

        return;
      }

      model.view.loading();
      dataServices.get('docer').user({ cookie: {
        wps_sid: model.wpsSid
      }}).done(function (result) {
        if (result.result == 'ok') {
          model.user.nickname = result.data.nickname;
          model.user.wealth = result.data.wealth;
          model.user.loaded = true;

          var payway = model.user.wealth >= model.displayInfo.price ? PayWay.RICE : PayWay.ALIPAY;
          model.template.selectPayWay(payway);
          model.view.loaded();
          if (!uiInited) {
            uiInited = true;
            collectApi.sendPaymentDisplay(payway + 1);
          }
        } else {
          model.view.unknownError();
        }
      }).fail(function (errorCode) {
        failFunc(errorCode);
        collectApi.sendPaymentLoadFail(collectApi.IC_FAIL_TARGET.PAGE);
      });
    };

    vm.refresh = function () {
      if (!model.view.isLoading) {
        model.queryUserInfoAndSelectPayWay();
      }
    };

    vm.rechargeRice = function () {
      model.isPayForTemplate = false;
      model.isPayForRice = true;
      model.updateDragArea();
      model.rice.retryPay();
    };

    vm.rechargeRiceClick = function () {
      model.rechargeRice();
      collectApi.sendPaymentClickBtn(IC_TARGET_INDEX.TEMPLATE, IC_TEMPLATE_BTN_INDEX.LINK_RICE_CHARGE);
    };

    vm.back = function () {
      if (!model.view.isLoading) {
        model.queryUserInfoAndSelectPayWay();
      }
    };
  });

  model.init();

  return model;
});



/** WEBPACK FOOTER **
 ** ./src/modules/unipay/scripts/controllers/payment.js
 **/